import { Component, OnInit, TemplateRef, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { LinkComponent } from '../link/link.component';
import { ButtonRowComponent } from '../button-row/button-row.component';
import { PrimaryButtonComponent } from '../primary-button/primary-button.component';
import { CommonModule } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';

interface ButtonRowData {
  confirmButtonText: string;
  confirmButtonAction: () => void;
  declineButtonText: string;
  confirmButtonDisabled?: boolean;
  confirmButtonLoading: boolean;
}
interface DialogData {
  headline: string;
  closable: boolean;
  description?: SafeHtml | string;
  linkDescription?: string;
  linkHref?: string;
  secondDescription?: string;
  secondLinkDescription?: string;
  secondLinkHref?: string;
  thirdDescription?: string;
  fourthDescription?: string;
  fifthDescription?: string;
  sixthDescription?: string;
  seventhDescription?: string;
  footerDescription?: string;
  footerLinkDescription?: string;
  footerDescriptionEnding?: string;
  footerLinkAction?: () => void;
  additionalFooterDescription?: string;
  additionalFooterLinkDescription?: string;
  additionalFooterLinkAction?: () => void;
  buttonRowData?: ButtonRowData;
  confirmButtonText?: string;
  confirmButtonAction?: () => void;
  topButtonFooter?: {
    text: string;
    action: () => void;
    isLoading?: boolean;
    disabled?: boolean;
  };
  contentTemplate?: TemplateRef<Element>;
}

const DIALOG_POSITION_TOP = '130px';

@Component({
  imports: [
    LinkComponent,
    MatDialogModule,
    ButtonRowComponent,
    PrimaryButtonComponent,
    CommonModule,
  ],
  templateUrl: './dialog.component.html',
})
export class DialogViewComponent implements OnInit {
  dialogRef = inject<MatDialogRef<DialogViewComponent>>(MatDialogRef);
  data = inject<DialogData>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.dialogRef.updatePosition({ top: DIALOG_POSITION_TOP });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onFooterTopButtonClick(): void {
    this.data.topButtonFooter?.action();
  }

  confirmButtonClickFromButtonRow(): void {
    this.data.buttonRowData?.confirmButtonAction();
  }

  confirmButtonClick(): void {
    this.data.confirmButtonAction?.();
  }
}
